import { Auth } from 'aws-amplify';
const PORT = process.env.NODE_ENV === 'development' ? 3001 : window.location.port;
export const BASE_URL = `//${window.location.hostname}:${PORT}/api/latest`;
export const APPLICATION_JSON_TYPE = 'application/json';
export const TEXT_CSV_TYPE = 'application/octet-stream';
export const APPLICATION_ZIP_TYPE = 'application/zip';

function getFileNameFromDisposition(disposition) {
  const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
  const filename = filenameRegex.exec(disposition)[1];
  return filename.replace(/"/g, '');
}

async function handleResponse(response) {
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message);
  }

  const contentType = response.headers.get('content-type');
  if (contentType.includes(APPLICATION_JSON_TYPE)) {
    return response.json();
  }

  if (contentType.includes(APPLICATION_ZIP_TYPE) || contentType.includes(TEXT_CSV_TYPE)) {
    const disposition = response.headers.get('content-disposition');
    const filename = getFileNameFromDisposition(disposition);

    return {
      filename,
      data: await response.blob(),
    };
  }

  return response.text();
}

export async function uploadFiles(uploadState, offset = 0, limit = 1, sessionId) {
  const formData = new FormData();
  uploadState.files.forEach(file => {
    formData.append('files', file);
  });

  formData.append('template', uploadState.templateFile);
  formData.append('sessionName', uploadState.name);

  const optionalQueryString = sessionId ? `&sessionId=${sessionId}` : '';
  const response = await fetchAuthenticated(`${BASE_URL}/upload/fileupload?offset=${offset}&limit=${limit}${optionalQueryString}`, {
    method: 'post',
    headers: {
      accept: APPLICATION_JSON_TYPE,
       'content-transfer-encoding': 'utf-8',
    },
    body: formData,
  });

  return response;
}

export async function deleteSession(sessionId) {
  const response = await fetchAuthenticated(`${BASE_URL}/session/${sessionId}`, {
    method: 'delete',
    headers: {
      accept: APPLICATION_JSON_TYPE,
    },
  });

  return response;
}

export async function hideSession(sessionId,hide) {
  const response = await fetchAuthenticated(`${BASE_URL}/session/${sessionId}/hide/${hide}`, {
    method: 'put',
    headers: {

    }
  });
  return response;
}

export async function deleteFileFromSession(sessionId, fileId) {
  const response = await fetchAuthenticated(`${BASE_URL}/session/${sessionId}/files/${fileId}`, {
    method: 'delete',
    headers: {
      accept: APPLICATION_JSON_TYPE,
    },
  });

  return response;
}

export async function fetchSessionFile(sessionId, fileId, offset = 0, limit = 50) {
  const response = await fetchAuthenticated(`${BASE_URL}/session/${sessionId}/files/${fileId}?offset=${offset}&limit=${limit}`, {
    method: 'get',
    headers: {
      accept: APPLICATION_JSON_TYPE,
    },
  });
  return response;
}

export async function fetchSessionFiles(sessionId) {
  const response = await fetchAuthenticated(`${BASE_URL}/session/${sessionId}/files`, {
    method: 'get',
    headers: {
      accept: APPLICATION_JSON_TYPE,
    },
  });

  return response;
}

export async function fetchSessions() {

  return await fetchAuthenticated(`${BASE_URL}/session`, {
    method: 'get',
    headers: {
      accept: APPLICATION_JSON_TYPE,

    },
  });


}

export async function fetchParsedMappingFile(file) {
  const formData = new FormData();
  formData.append('file', file[0]);

  const response = await fetchAuthenticated(`${BASE_URL}/upload/mapping`, {
    method: 'post',
    headers: {
      accept: APPLICATION_JSON_TYPE,
      'content-transfer-encoding': 'utf-8',
    },
    body: formData,
  });

  return response;
}

export async function fetchHeadersOfSessionFile(sessionId, fileId) {
  const response = await fetchAuthenticated(`${BASE_URL}/session/${sessionId}/files/${fileId}/headers`, {
    method: 'get',
    headers: {
      accept: APPLICATION_JSON_TYPE,
    },
  });

  return response;
}

export async function updateSessionFileActive(sessionId, fileId, active = false) {
  const response = await fetchAuthenticated(`${BASE_URL}/session/${sessionId}/files/${fileId}/active`, {
    method: 'put',
    headers: {
      'Content-Type': APPLICATION_JSON_TYPE,
    },
    body: JSON.stringify({
      active,
    }),
  });

  return response;
}
export async function updateSessionFileName(sessionId, fileId, filename = '') {
  const response = await fetchAuthenticated(`${BASE_URL}/session/${sessionId}/files/${fileId}/filename`, {
    method: 'put',
    headers: {
      'Content-Type': APPLICATION_JSON_TYPE,
    },
    body: JSON.stringify({
      filename,
    }),
  });

  return response;
}

export async function updateSessionName(sessionId, data) {
  const response = await fetchAuthenticated(`${BASE_URL}/session/${sessionId}/name`, {
    method: 'put',
    headers: {
      'Content-Type': APPLICATION_JSON_TYPE,
    },
    body: JSON.stringify(data),
  });

  return response;
}

export async function saveSession(sessionId, data) {
  const response = await fetchAuthenticated(`${BASE_URL}/session/${sessionId}`, {
    method: 'post',
    headers: {
      'Content-Type': APPLICATION_JSON_TYPE,
    },
    body: JSON.stringify(data),
  });

  return response;
}

export async function downloadConversion(sessionId, fileId) {
  const response = await fetchAuthenticated(`${BASE_URL}/conversion/${sessionId}/file/${fileId}`, {
    method: 'get',
    headers: {
      accept: TEXT_CSV_TYPE,
    },
  });

  return response;
}

export async function downloadParagonFile(sessionId, fileId) {
  const response = await fetchAuthenticated(`${BASE_URL}/conversion/${sessionId}/file/${fileId}?isTransaction=true`, {
    method: 'get',
    headers: {
      accept: TEXT_CSV_TYPE,
    },
  });

  return response;
}

export async function downloadConversionZip(sessionId) {
  const response = await fetchAuthenticated(`${BASE_URL}/conversion/${sessionId}/convertall`, {
    method: 'get',
    headers: {
      accept: APPLICATION_ZIP_TYPE,
    },
  });

  return response;
}

export async function downloadAttributeFile(sessionId, fileId) {
  const response = await fetchAuthenticated(`${BASE_URL}/conversion/${sessionId}/file/${fileId}/attributefile`, {
    method: 'get',
    headers: {
      accept: TEXT_CSV_TYPE,
    },
  });

  return response;
}

export async function downloadMappingFile(sessionId, fileId) {
  const response = await fetchAuthenticated(`${BASE_URL}/conversion/${sessionId}/file/${fileId}/mappingfile`, {
    method: 'get',
    headers: {
      accept: TEXT_CSV_TYPE,
    }
  })

  return response;
}

export async function downloadAttributeFileZip(sessionId) {
  const response = await fetchAuthenticated(`${BASE_URL}/conversion/${sessionId}/allattributefiles`, {
    method: 'get',
    headers: {
      accept: TEXT_CSV_TYPE,
    },
  });

  return response;
}
export async function downloadMappingZip(sessionId) {
  const response = await fetchAuthenticated(`${BASE_URL}/conversion/${sessionId}/allmappingfiles`, {
    method: 'get',
    headers: {
      accept: APPLICATION_ZIP_TYPE,
    },
  });

  return response;
}

export async function downloadTemplateFile(sessionId) {
  const response = await fetchAuthenticated(`${BASE_URL}/template/${sessionId}/export`, {
    method: 'get',
    headers: {
      accept: APPLICATION_JSON_TYPE,
    },
  });

  const json = await response;

  return {
    filename: `template_${json.name}.ttt`,
    data: JSON.stringify(json),
  };
}

export async function bounceJoinFile(sessionId, fileId, name) {
  const response = await fetchAuthenticated(`${BASE_URL}/conversion/${sessionId}/file/${fileId}/bounce?newname=${name}`, {
    method: 'get',
    headers: {
      accept: APPLICATION_JSON_TYPE,
    },
  });

  return response;
}
export async function moveVirtualFile(sessionId,fileId,amountDown) {
  const response = await fetchAuthenticated(`${BASE_URL}/session/${sessionId}/files/virtual/move`, {
    method:'put',
    headers: {
      'Content-Type': APPLICATION_JSON_TYPE,
    },
    body: JSON.stringify({
      fileId: fileId,
      amount: amountDown
    })
  })
  return response;
}
export async function fetchAuthenticated(input, init) {
  const currentSession = await Auth.currentSession();
  init.headers.accessToken = currentSession.getAccessToken().getJwtToken();
  init.headers.userid = currentSession.getIdToken().payload[`cognito:username`]
  const response = await fetch(input, init);

  return handleResponse(response);
}
